$(function() {
  //$("#accordion").accordion({ autoHeight: true});
  $("#accordion").accordion({ 
    header: "h4",
    collapsible: true,
    autoHeight: false,
    navigation: true  
  });
  
  $("ul.site-footer__linklist h4").click(function(){
    $(this).parent("ul").toggleClass("ulmin");
    $(this).parent("ul").find("li").toggle();
  });
  
  $(".add-success .content .action .btn.continue").click(function(){
    $(".add-success").hide();
    //location.reload(true);
  });
  
  $(".site-header__cart").click(function(e){
    //e.preventDefault()
    //$(".mini-cart").fadeToggle();
  });
  
  $(".mini-cart .action a.close").click(function(e){
    //e.preventDefault()
    //$(".mini-cart").fadeOut();
  });
  
  // Scroll thumb image product
  $(".scroll-prev").click(function(){
    var heightcontent = $("ul.product-single__thumbnails").height() - '430';
    var liCount = $("ul.product-single__thumbnails").children().length - '5';
    //alert(heightcontent);
    if ($("ul.product-single__thumbnails").css('marginTop') == '-' + heightcontent + 'px'){
      $("scroll-prev").addClass('disabled');
      //$("ul.two").css({marginTop: '0px'});
    } else {
      $("ul.product-single__thumbnails").animate({
        marginTop: '+=-86px'
      });
    }
  });
  $(".scroll-next").click(function(){
    if ($("ul.product-single__thumbnails").css('marginTop') == '0px'){
      $(".scroll-next").addClass('disabled');
      //$("ul.product-single__thumbnails").css({marginTop: '0px'});
    } else {
      $("ul.product-single__thumbnails").animate({
        marginTop: '+=86px'
      });
    }
  });
  
  // Popup zoom - Product 
  $(".zoom-gallery a").click(function(event){
    event.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, "slow");
    $(".popup-zoom").show();
    $("body").css("overflow", "hidden");
    $(".site-header__search").css("opacity", "0");
  });
  
  $(".click-close").click(function(event){
    event.preventDefault();
    //$("html, body").animate({ scrollTop: 0 }, "slow");
    $(".popup-zoom").hide();
    $("body").css("overflow", "");
    $(".site-header__search").css("opacity", "");
  });
  
});

function addItemFromForm(t)
{
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    beforeSend: function() { 
      $(".loading-modalx").show();
    },
    data:  $("#"+t).serialize(),
    success: getcart,
    error: errorinfo
  });

}
function getcart()
{

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(response)
    {
      $(".loading-modalx").hide();
      $('.site-header__cart-count').html('<span>' + response.item_count + '</span>');
      $(".add-success").fadeIn().delay(3000);
    },
    error: errorinfo
  });
  
  $(".cart-box").load("https://cambridge-casual.myshopify.com" + "/cart?view=iframe");
}
function errorinfo(obj)
{
  $(".ajax-error-message").text($.parseJSON(obj.responseText).description);
  try {
    $(error_div).html(obj.description).fadeIn(300).delay(show_msg_delay).fadeOut(300);
  } catch(e) {
    $(error_div).html("There was an error").fadeIn(300).delay(show_msg_delay).fadeOut(300);
  }
}

function close_window() {
  close();
  $(".mini-cart").fadeOut();
}

